import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5fea15fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Relevant policy:", -1))
const _hoisted_2 = ["name", "id", "value"]
const _hoisted_3 = ["for"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "autofill-select-none" }, "Don't autofill policy fields", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = {
  key: 3,
  class: "ticket-field-error"
}
const _hoisted_11 = { key: 4 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.policyNumbers.length > 0)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _hoisted_1,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.policyNumbers, (policyNumber) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: policyNumber }, [
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectedPolicyNumber = $event)),
                name: policyNumber,
                id: 'autofill-select-' + policyNumber,
                value: policyNumber
              }, null, 8, _hoisted_2), [
                [_vModelRadio, _ctx.selectedPolicyNumber]
              ]),
              _createElementVNode("label", {
                for: 'autofill-select-' + policyNumber
              }, _toDisplayString(policyNumber), 9, _hoisted_3),
              _hoisted_4
            ], 64))
          }), 128)),
          _withDirectives(_createElementVNode("input", {
            type: "radio",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedPolicyNumber = $event)),
            id: "autofill-select-none",
            name: "none",
            value: "",
            key: "none"
          }, null, 512), [
            [_vModelRadio, _ctx.selectedPolicyNumber]
          ]),
          _hoisted_5,
          _hoisted_6
        ], 64))
      : _createCommentVNode("", true),
    _createElementVNode("button", {
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.autofillTicketFields())),
      disabled: !_ctx.accountInfo || _ctx.isLoading || _ctx.isLoadingBilling
    }, " Autofill ", 8, _hoisted_7),
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, "Populating ticket fields..."))
      : _createCommentVNode("", true),
    (_ctx.isLoadingBilling)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, "Fetching ticket info..."))
      : _createCommentVNode("", true),
    (_ctx.hasError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, "There was an error in populating ticket fields"))
      : _createCommentVNode("", true),
    (_ctx.hasSuccess)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, "Succesfully populated ticket fields"))
      : _createCommentVNode("", true)
  ]))
}